import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const StatusCardHeader = styled.div`
  padding: 0 ${Spacing.S16};
`
